<template>
  <div>
    <v-hover v-slot="{ hover }">
      <div :class="{ 'hoveredBackground': hover }" class="cursorPointer" @click="editTechnicalSkills">
        <v-banner class="banner-without-padding py-1" style="top:50px; z-index:1" sticky color="primary" single-line>
          <v-layout wrap>
            <v-flex xs12 class="primary white--text" text-center>
              <h3>
                <span>{{ $t('a') }}</span>
                <v-icon small class="ml-2" :class="{ 'white--text': hover, 'primary--text': !hover }">mdi-pen</v-icon>
              </h3>
            </v-flex>
          </v-layout>
        </v-banner>
        <v-divider/>
        <v-layout wrap>
          <v-flex xs12 v-if="dossier.profile.skills.isUsingTechnicalSkillsDescription">
            <v-layout wrap>
              <v-flex xs12 v-if="dossier.profile.skills.technicalSkillsDescription" class="quillAsHtmlContainer" pl-1>
                <div class="quillAsHtml" v-html="dossier.profile.skills.technicalSkillsDescription"></div>
              </v-flex>
              <v-flex xs12 v-else>
                <v-layout wrap>
                  <v-flex xs3></v-flex>
                  <v-flex xs9 pl-2>
                    <i>{{ $t('b') }}</i>
                  </v-flex>
                </v-layout>  
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 v-else-if="dossier.isUsingParserV2">
            <v-layout wrap v-if="dossier.profile.skills.technicalSkillsV2.mainSkills.length > 0">
              <v-flex xs12>
                <v-layout wrap>
                  <v-flex xs3 class="leftCell" pl-1>
                    {{ mainSkillsTitleDict[user.data.locale.toUpperCase()] }}
                  </v-flex>
                  <v-flex xs9 pl-2>
                    {{ dossier.profile.skills.technicalSkillsV2.mainSkills.join(', ') }}.
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-divider/>
              </v-flex>
            </v-layout>
            <v-layout wrap v-for="(category, key) in dossier.profile.skills.technicalSkillsV2.categories" :key="key">
              <v-flex xs12>
                <v-layout wrap>
                  <v-flex xs3 class="leftCell" pl-1>
                    {{ category.category }}
                  </v-flex>
                  <v-flex xs9 pl-2>
                    {{ category.skills.join(', ') }}.
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-divider/>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="dossier.profile.skills.technicalSkillsV2.mainSkills.length === 0 && dossier.profile.skills.technicalSkillsV2.categories.length === 0">
              <v-flex xs3>
              </v-flex>
              <v-flex xs9 pl-2>
                <i>{{ $t('c') }}</i>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 v-else>
            <v-layout wrap v-for="(category, key) in categoriesForDisplay" :key="key">
              <v-flex xs12>
                <v-layout wrap>
                  <v-flex xs3 class="leftCell" pl-1>
                    {{ category.name }}
                  </v-flex>
                  <v-flex xs9 pl-2>
                    {{ category.text }}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-divider/>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="categoriesForDisplay.length === 0">
              <v-flex xs3>
              </v-flex>
              <v-flex xs9 pl-2>
                <i>{{ $t('c') }}</i>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </v-hover>
  </div>
</template>

<script>
const allSkills = require('@/assets/app/data/allSkills.json')
const allCategories = require('@/assets/app/data/allCategories.json')

const mainSkillsTitleDict = {
  "FR": "Compétences principales",
  "EN": "Main skills",
  "DE": "Kernkompetenzen",
  "ES": "Competencias principales",
  "IT": "Competenze principali",
  "PT": "Competências principais",
  "NL": "Kerncompetenties",
  "RU": "Основные навыки",
  "UNKNOWN": "Compétences principales"
}

import { mapGetters } from "vuex";

export default {
  props: {
    dossier: Object
  },
  data: () => ({
    mainSkillsTitleDict: mainSkillsTitleDict
  }),
  computed: {
    ...mapGetters({
      user: "user"
    }),
    categoriesForDisplay() {
      let categories = []
      // Create categories
      for (const [categoryId, categoryNamesDict] of Object.entries(allCategories)) {
        categories.push({
          id: categoryId,
          name: categoryNamesDict[this.user.data.locale.toUpperCase()],
          skills: [],
          text: ''
        })
      }
      
      // Add them their skills
      for (let skill of this.dossier.profile.skills.technicalSkills) {
        const skillCategoryId = this.getSkillById(skill.id).categoryId
        for (let category of categories) {
          if (skillCategoryId === category.id) {
            category.skills.push(skill)
          }
        }
      }

      // Sort the skills by their names
      for (let category of categories) {
        category.skills.sort((a, b) => this.getSkillById(a.id).name > this.getSkillById(b.id).name ? 1 : -1)
      }

      // Sort the categories by their number of skills
      categories = categories.filter(category => category.skills.length > 0).sort((a,b) => {
        if (b.skills.length === a.skills.length) return a.name > b.name ? 1 : -1
        else return b.skills.length - a.skills.length
      })

      // If too many categories, group all categories that have only one skill, into a single "Other" category.
      if (categories.length > 9) {
        let categoriesWithGroupedSingleSkills = []
        const groupingCategoryName = {
          "FR": "Autres",
          "EN": "Others",
          "DE": "Andere",
          "ES": "Otros",
          "IT": "Altro",
          "PT": "Outros",
          "NL": "Andere",
          "RU": "Другое"
        }[this.user.data.locale.toUpperCase()]
        const groupingCategory = {
          name: groupingCategoryName,
          skills: []
        }
        for (let category of categories) {
          if (category.skills.length > 1) {
            categoriesWithGroupedSingleSkills.push(category)
          } else {
            groupingCategory.skills = groupingCategory.skills.concat(category.skills)
          }
        }
        groupingCategory.skills = groupingCategory.skills.sort((a, b) => this.getSkillById(a.id).name > this.getSkillById(b.id).name ? 1 : -1)
        if (groupingCategory.skills.length > 0) categoriesWithGroupedSingleSkills.push(groupingCategory)
        categories = categoriesWithGroupedSingleSkills
      }

      // Add text by joining skill names
      categories = categories.map(category => {
        category.text = category.skills.map(skill => this.getSkillById(skill.id).name).join(', ') + '.'
        return category
      })


      // Add mainSkills category
      const mainSkills = this.dossier.profile.skills.technicalSkills.filter(skill => skill.isMain)

      if (mainSkills.length > 0) {
        categories.unshift({
          id: 'main_skills',
          name: mainSkillsTitleDict[this.user.data.locale.toUpperCase()],
          skills: mainSkills,
          text: mainSkills.map(skill => this.getSkillById(skill.id).name).join(', ') + '.'
        })
      }

      return categories
    }
  },
  methods: {
    editTechnicalSkills() {
      this.$emit('setFieldPath', { fieldPath: ['technicalSkills'], savedScrollEltId: `view-technicalSkills` })
    },
    getSkillById(skillId) {
      const skill = allSkills.find(skill => skill.id === skillId || skill.legacyId === skillId)
      if (skill) return skill
      else {
        // Custom skill here
        return this.dossier.profile.skills.technicalSkills.find(skill => skill.id === skillId)
      }
    },
  }
}
</script>


<i18n>
{
  "fr": {
    "a": "Compétences techniques",
    "b": "Vide.",
    "c": "Aucune compétence technique."
  },
  "en": {
    "a": "Technical skills",
    "b": "Empty.",
    "c": "No technical skill."
  }
}
</i18n>